var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 48,
    viewBox: "0 0 66 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 64,
    height: 46,
    rx: 23,
    stroke: "#2F1C0A",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 14)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.85714,
    cy: 1.85714,
    r: 1.85714,
    fill: "#2F1C0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42857 1.85714C7.42857 1.33714 7.83714 0.928571 8.35714 0.928571H25.0714C25.5914 0.928571 26 1.33714 26 1.85714C26 2.37714 25.5914 2.78571 25.0714 2.78571H8.35714C7.83714 2.78571 7.42857 2.37714 7.42857 1.85714Z",
    fill: "#2F1C0A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.85714,
    cy: 9.28571,
    r: 1.85714,
    fill: "#2F1C0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42857 9.28571C7.42857 8.76571 7.83714 8.35714 8.35714 8.35714H25.0714C25.5914 8.35714 26 8.76571 26 9.28571C26 9.80571 25.5914 10.2143 25.0714 10.2143H8.35714C7.83714 10.2143 7.42857 9.80571 7.42857 9.28571Z",
    fill: "#2F1C0A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.85714,
    cy: 16.7143,
    r: 1.85714,
    fill: "#2F1C0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42857 16.7143C7.42857 16.1943 7.83714 15.7857 8.35714 15.7857H25.0714C25.5914 15.7857 26 16.1943 26 16.7143C26 17.2343 25.5914 17.6429 25.0714 17.6429H8.35714C7.83714 17.6429 7.42857 17.2343 7.42857 16.7143Z",
    fill: "#2F1C0A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListview);
export default __webpack_public_path__ + "static/media/listview.d8671123bf0ea2941895ff5f8f3510ae.svg";
export { ForwardRef as ReactComponent };